import cn from 'classnames';

import s from './ErrorTitle.module.css';

export interface ErrorTitleProps {
  title: string;
  className?: string;
}

export function ErrorTitle({title, className}: ErrorTitleProps): JSX.Element {
  return <h1 className={cn(s.title, className)}>{title}</h1>;
}
